module.exports = __webpack_public_path__ + "assets/img/mecha-btn-69c182d1.png";